import { randomBetween } from '@/lib/random';

const randomizeVolume = function randomizeVolume(config) {
	const min = (config.volume - config.volume_variation) * 100;
	const max = (config.volume + config.volume_variation) * 100;
	return randomBetween(min, max) / 100;
};

export { randomizeVolume };
export default randomizeVolume;



// WEBPACK FOOTER //
// ./src/lib/sound.js